import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "cart-price-item" }
const _hoisted_2 = {
  key: 0,
  class: "cart-price-item__pricing-item"
}
const _hoisted_3 = { class: "cart-price-item__product-name-and-number" }
const _hoisted_4 = { class: "cart-price-item__product-name" }
const _hoisted_5 = {
  key: 0,
  class: "cart-price-item__campaign"
}
const _hoisted_6 = {
  key: 1,
  class: "cart-price-item__details-spacer"
}
const _hoisted_7 = { class: "cart-price-item__article-number" }
const _hoisted_8 = { class: "cart-price-item__quantity-and-price" }
const _hoisted_9 = { class: "cart-price-item__quantity" }
const _hoisted_10 = { class: "cart-price-item__price" }
const _hoisted_11 = {
  key: 1,
  class: "cart-price-item__pricing-item"
}
const _hoisted_12 = { class: "cart-price-item__product-name-and-number" }
const _hoisted_13 = { class: "cart-price-item__decoration-name" }
const _hoisted_14 = { class: "cart-price-item__product-fee-name" }
const _hoisted_15 = { class: "cart-price-item__price" }
const _hoisted_16 = { class: "cart-price-item__quantity-and-price" }
const _hoisted_17 = { class: "cart-price-item__quantity" }
const _hoisted_18 = { class: "cart-price-item__price" }

import { computed } from 'vue';
import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*@__PURE__*/_defineComponent({
  __name: 'CartPriceItem',
  props: {
  item: {
    type: Object,
    required: true,
  },
  isDecoration: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { websiteText } = useWebsiteTexts();
const { formatPrice } = useContext();
const printAddons = computed(() => props.item.addons || []);
const quantity = computed(() => props.item.quantity);

const unitPrice = computed(() => {
  if (props.isDecoration) return props.item.unitPrice;
  if (!props.item.originalPrice) return props.item.currentPrice;
  return props.item.currentPrice < props.item.originalPrice
    ? props.item.currentPrice
    : props.item.originalPrice;
});

const priceSum = computed(() => {
  return unitPrice.value * props.item.quantity;
});

const quantityText = computed(() => {
  return `${quantity.value} ${websiteText('productdetailspage_printpieceabbreviated').value}`;
});

const pricePerItemText = computed(() => {
  return `(${formatPrice(unitPrice.value)}/${websiteText('productdetailspage_printpieceabbreviated').value})`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.isDecoration)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(__props.item.name), 1),
            (__props.item.campaignPercentage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " (-" + _toDisplayString(__props.item.campaignPercentage) + "%) ", 1))
              : _createCommentVNode("", true),
            (__props.item.articleNumber)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, _toDisplayString(__props.item.articleNumberForDisplay), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(quantityText.value) + " " + _toDisplayString(pricePerItemText.value), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(formatPrice)(priceSum.value)), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.isDecoration)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(__props.item.name || 'DecorationName'), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(printAddons.value, (printAddon) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "cart-price-item__product-fee",
              key: printAddon.id
            }, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(printAddon.name), 1),
              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(formatPrice)(printAddon.unitPrice)), 1)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(quantityText.value) + " " + _toDisplayString(pricePerItemText.value), 1),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(formatPrice)(priceSum.value)), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})